import React, { useState } from 'react';

import { observer } from 'mobx-react';

import { Button } from '@infoods/lifebase-ui';

import { nutritionRegistrationService } from '../../../../../auth-management';
import { loggedInUserDataStore } from '../../../../../shared/stores/loggedInUserDataStore';
import { openNewTab } from '../../../../../shared/utils/windowUtils';

const AddNewFlow2024CustomerButton = observer(() => {
  const [registrationLink, setRegistrationLink] = useState<string | null>('');
  const { isCoach, isComplianceCoach, getEntityId } = loggedInUserDataStore;
  const isShowAddCustomerMenu = isCoach && !isComplianceCoach;

  if (!isShowAddCustomerMenu) {
    return null;
  }

  const handleAddCustomer = async () => {
    if (registrationLink) {
      openNewTab(registrationLink);
    } else {
      const entityId = getEntityId();
      const { url } = await nutritionRegistrationService.getRegistrationLink(entityId);

      setRegistrationLink(url);
      openNewTab(url);
    }
  };

  return (
    <Button variant="contained" onClick={handleAddCustomer}>
      Add New Customer
    </Button>
  );
});

export { AddNewFlow2024CustomerButton };
